const initialState = {
  plans: [],
  error: null,
  isLoding: false
};

const SubscripationPlanApiReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING":
      return {
        ...state,
        isLoding: action.payload
      };

    case "GET_PLANS_SUCCESS":
      return {
        ...state,
        plans: action.payload,
        error: null
      };
    case "GET_PLANS_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "ADD_PLANS_SUCCESS":
      return {
        ...state,
        error: null
      };
    case "ADD_PLANS_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_PLANS_SUCCESS":
      return {
        ...state,
        error: action.payload.error
      };

    case "UPDATE_PLANS_FAILURE":
      return {
        ...state,

        error: action.payload.error
      };

    case "DELETE_PLANS_SUCCESS":
      return {
        ...state,
        plans: state.plans.filter(
          (plan) => plan.id !== action.payload
        ),
        error: null
      };

    case "DELETE_PLANS_FAILURE":
      return {
        ...state,
        error: action.payload.error
      };
    default:
      return state;
  }
};

export default SubscripationPlanApiReducer;
